import { createContext } from 'react';
import { ICON_PREFIX } from '../constants';
var IconContext = createContext({ prefixCls: ICON_PREFIX });
export default IconContext;
